'use client';
import Section from '@repo/ui/src/components/Section';
import { AlignH } from '@repo/ui/src/types/general';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import { useIsMD } from '@repo/ui/src/utils/useMediaQuery';

interface Props {
  darkMode: boolean;
  useTexture: boolean;
  heading: string;
  headerVariation: any;
  headerAlign: AlignH;
  leftColumn: string;
  leftColumnAlign: AlignH;
  rightColumn: string;
  rightColumnAlign: AlignH;
  className?: string;
}

export const TitledSplitToutContent = ({
  darkMode,
  useTexture,
  heading,
  headerVariation,
  headerAlign,
  leftColumn,
  leftColumnAlign,
  rightColumn,
  rightColumnAlign,
  className,
}: Props) => {
  const mdAndUp = useIsMD();
  const computedHeaderAlign = mdAndUp ? headerAlign || 'center' : 'left';

  return (
    <div className={className}>
      <Section dark={darkMode} texture={useTexture} gutterX basePadding gutterY>
        <div className="grid grid-cols-12 gap-x-4">
          {/* Top divider */}
          <div className="col-span-12 mb-6 after:content-[''] after:block after:h-2 after:w-20 after:bg-brand-300 after:mx-auto" />

          {/* Heading section */}
          <div className="hidden md:block md:col-span-2" />
          <div className="col-span-12 md:col-span-8 py-4 md:pb-12 max-md:pb-4">
            <ToutContent
              dark={darkMode}
              heading={heading}
              headerVariation={headerVariation || 'h2'}
              headingStyleVariant="h1"
              align={computedHeaderAlign}
            />
          </div>
          <div className="hidden md:block md:col-span-2" />

          {/* Left and Right columns */}
          <div className="hidden md:block md:col-span-2" />
          <div className="col-span-12 md:col-span-4 pb-4 md:pr-3 max-md:pr-0">
            <ToutContent
              dark={darkMode}
              headingLight={leftColumn}
              headingStyleVariant="h3"
              align={leftColumnAlign || 'left'}
              fullWidth
            />
          </div>
          <div className="col-span-12 md:col-span-4 pb-4 md:pl-3 max-md:pl-0">
            <ToutContent
              dark={darkMode}
              description={rightColumn}
              align={rightColumnAlign || 'left'}
              fullWidth
            />
          </div>
          <div className="hidden md:block md:col-span-2" />

          {/* Bottom divider */}
          <div className="col-span-12 mt-6 after:content-[''] after:block after:h-2 after:w-20 after:bg-brand-300 after:mx-auto" />
        </div>
      </Section>
    </div>
  );
};

export default TitledSplitToutContent;
